export const appointmentSect = {
  uz: {
    appSectTitle: "Bizning klinikamiz ochiq & <br/> yordam berishga tayyor!",
    appSectBtn: "Konsultatsiya olish",
    appSectText: "Har kuni tibbiy ma'lumot oling. Telefon orqali uchrashuvga yoziling!",
    appSectSamarkandBranch: "Samarqand filiali",
    appSectXatirchiBranch: "Xatirchi filiali",
  },
  ru: {
    appSectTitle: "Наша клиника открыта & <br/> готова помочь!",
    appSectBtn: "Получить консультацию",
    appSectText: "Запишитесь на приём по телефону и получите квалифицированную офтальмологическую помощь от наших специалистов.",
    appSectSamarkandBranch: "Самаркандский филиал",
    appSectXatirchiBranch: "Хатырчинский филиал",
  },
  tj: {
    appSectTitle: "Клиникаи мо кушода аст & <br/> омодагирӣ ба кӯмак!",
    appSectBtn: "Машварат гиред",
    appSectText: "Ҳар рӯз маълумоти тиббӣ гиред. Бо телефон таъин кунед!",
    appSectSamarkandBranch: "Филиали Самарқанд",
    appSectXatirchiBranch: "Филиали Хатирчи",
  },
};
